
export var bestServices=[
    {
      icon:"/assets/c.png",
      text:'Restaurant Gourmet'
    },

    {
      icon:'/assets/c.png',
      text:'Servicio de habitaciones'
    },
    {
      icon:'/assets/c.png',
      text:'Bar Tematico'
    },
    {
      icon:'/assets/c.png',
      text:'El mejor cafe colombiano'
    },
    {
      icon:'/assets/c.png',
      text:'Actividades nocturnas'
    }
  ]

export var blackServices=
[
    {
        name:"Baño",
        icon:"/favicon.ico",
        list:["Papel higienico", "toallas", "duchas", "WC", "Articulos de aseo gratis"]
    },

    {
        name:"Comida y bebida",
        icon:"/favicon.ico",
        list:["Carnes", "frutas", "3 bebidas gratis", "infusiones", "agua gratis"]
    },
    {
        name:"Seguridad",
        icon:"/favicon.ico",
        list:["Caja fuerte", "Camaras de seguridad", "detectores de humo", "WC", "Articulos de aseo gratis"]
    },
    {
        name:"Seguridad",
        icon:"/favicon.ico",
        list:["Caja fuerte", "Camaras de seguridad", "detectores de humo", "WC", "Articulos de aseo gratis"]
    },
    {
        name:"Seguridad",
        icon:"/favicon.ico",
        list:["Caja fuerte"]
    },
    {
        name:"Seguridad",
        icon:"/favicon.ico",
        list:["Caja fuerte", "Camaras de seguridad"]
    }
]

export var comments = [
    {
      userName:"Raul",
      country:"Chile",
      imgUrl:"/favicon.ico",
      text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
    },
    {
        userName:"Carlos",
        country:"Cuba",
        imgUrl:"/favicon.ico",
        text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
      },
    {
      userName:"Carlos",
      country:"Cuba",
      imgUrl:"/img/cancun.jpg",
      text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
    }
    ,
    {
      userName:"Julio",
      country:"Canada",
      imgUrl:"/img/playa.jpg",
      text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
    },
    {
      userName:"Carlos",
      country:"Cuba",
      imgUrl:"/favicon.ico",
      text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
    },
    {
      userName:"Carlos",
      country:"Cuba",
      imgUrl:"/favicon.ico",
      text:"Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio Me parece un excelente hotel, tiene excelentes vistas, el servicio es es muy bueno, la comida exquisita, 5 estrellas (literalmente)"
    }
   
  ];

  export var listInfo=
  [
    {
      title:"Para cancelar debes pagar",
      text: "20 dolares"
    },
    {
      title:"Forma de pago",
      text: "Tarjeta de credito o bitcoin"
    },
    {
      title:"Oferta especial",
      text: "Si se queda mas de 3 noches le ofrecemos 2 almuerzos gratis"
    },
  ];

  export var room=
  {
    details:
    [
      {
        icon:"/favicon.ico",
        text:"Colchon de la Nasa"
      },
      {
        icon:"/favicon.ico",
        text:"Limpieza extrema"
      },
      {
        icon:"/favicon.ico",
        text:"Atencion 24 horas"
      }
    ],

    good:
    [
      {
        icon:"/favicon.ico",
        text:"25 m2"
      },
      {
        icon:"/favicon.ico",
        text:"Vistas a la ciudad"
      },
      {
        icon:"/favicon.ico",
        text:"Patio"
      },
      {
        icon:"/favicon.ico",
        text:"2 banhos"
      },
      {
        icon:"/favicon.ico",
        text:"100Mbps de internet"
      },
      {
        icon:"/favicon.ico",
        text:"Minibar"
      }
    ]
  }